/* ============================================================
   773 — utilitários do tema. Vanilla JS, sem dependências.
   Tudo é delegado no document, então funciona com seções
   recarregadas pelo editor do Shopify.
   ============================================================ */
(function () {
  'use strict';
  
  if (window.__t773Loaded) { return; }
  window.__t773Loaded = true;

  var money = function (cents) {
    return (cents / 100).toLocaleString('pt-BR', {
      style: 'currency', currency: 'BRL'
    });
  };
  window.t773Money = money;

  /* ---------- Accordion ---------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.acc__trigger');
    if (!trigger) return;
    var panel = trigger.nextElementSibling;
    var open = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', String(!open));
    if (panel) panel.setAttribute('data-open', String(!open));
  });

  /* ---------- Carrossel (setas) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rail-prev], [data-rail-next]');
    if (!btn) return;
    var scope = btn.closest('[data-rail-scope]');
    var rail = scope && scope.querySelector('.rail');
    if (!rail) return;
    var first = rail.firstElementChild;
    var step = first ? first.getBoundingClientRect().width + 20 : rail.clientWidth * 0.8;
    rail.scrollBy({
      left: btn.hasAttribute('data-rail-next') ? step : -step,
      behavior: 'smooth'
    });
  });

  /* ---------- Drawers / modais genéricos ---------- */
  function openDrawer(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.setAttribute('data-open', 'true');
    document.body.style.overflow = 'hidden';
    var focusable = el.querySelector('[data-drawer-close]');
    if (focusable) focusable.focus();
  }
  function closeDrawer(el) {
    if (!el) return;
    el.setAttribute('data-open', 'false');
    document.body.style.overflow = '';
  }
  window.t773OpenDrawer = openDrawer;

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(opener.getAttribute('data-drawer-open'));
      return;
    }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      e.preventDefault();
      closeDrawer(closer.closest('[data-drawer]'));
      return;
    }
    if (e.target.hasAttribute && e.target.hasAttribute('data-drawer-overlay')) {
      closeDrawer(e.target.closest('[data-drawer]'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-drawer][data-open="true"]').forEach(closeDrawer);
  });

  /* ---------- Carrinho: adicionar e abrir gaveta ---------- */
  function refreshCart() {
    return fetch('/?section_id=773-cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-contents]');
        var current = document.querySelector('[data-cart-contents]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        var count = doc.querySelector('[data-cart-count]');
        document.querySelectorAll('[data-cart-count]').forEach(function (n) {
          if (count) n.textContent = count.textContent;
        });
      });
  }
  window.t773RefreshCart = refreshCart;

  function addToCart(variantId, qty, button) {
    if (button) { button.setAttribute('aria-disabled', 'true'); button.dataset.loading = 'true'; }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || 'Não foi possível adicionar.');
        return refreshCart();
      })
      .then(function () { openDrawer('cart-drawer'); })
      .catch(function (err) {
        var msg = document.querySelector('[data-atc-error]');
        if (msg) { msg.textContent = err.message; msg.hidden = false; }
        else alert(err.message);
      })
      .finally(function () {
        if (button) { button.removeAttribute('aria-disabled'); delete button.dataset.loading; }
      });
  }
  window.t773AddToCart = addToCart;

  /* Quick-add pelo card de produto */
  document.addEventListener('click', function (e) {
    var size = e.target.closest('.quickadd__size[data-variant-id]');
    if (!size) return;
    e.preventDefault();
    addToCart(size.getAttribute('data-variant-id'), 1, size);
  });

  /* ---------- Alterar quantidade no carrinho ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-change]');
    if (!btn) return;
    e.preventDefault();
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        line: parseInt(btn.getAttribute('data-line'), 10),
        quantity: parseInt(btn.getAttribute('data-cart-change'), 10)
      })
    }).then(refreshCart);
  });

  /* ---------- Reveal no scroll ---------- */
  var io;
  function observeReveals() {
    var nodes = document.querySelectorAll('[data-reveal]:not(.is-in)');
    if (!nodes.length) return;
    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px' });
    }
    nodes.forEach(function (n) { io.observe(n); });
  }
  document.addEventListener('DOMContentLoaded', observeReveals);
  document.addEventListener('shopify:section:load', observeReveals);
  observeReveals();

  /* ---------- Contagem regressiva da barra de anúncio ---------- */
  function tickCountdowns() {
    document.querySelectorAll('[data-countdown]').forEach(function (el) {
      var target = new Date(el.getAttribute('data-countdown')).getTime();
      if (isNaN(target)) { el.hidden = true; return; }
      var diff = target - Date.now();
      if (diff <= 0) { el.hidden = true; return; }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      var pad = function (n) { return String(n).padStart(2, '0'); };
      var slots = el.querySelectorAll('[data-cd-value]');
      [d, h, m, s].forEach(function (v, i) { if (slots[i]) slots[i].textContent = pad(v); });
    });
  }
  setInterval(tickCountdowns, 1000);
  tickCountdowns();

  /* ---------- Calculadora de tamanho ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-size-calc-submit]');
    if (!btn) return;
    e.preventDefault();
    var form = btn.closest('[data-size-calc]');
    if (!form) return;

    var get = function (name) {
      var input = form.querySelector('[name="' + name + '"]');
      return input ? parseFloat(input.value) : NaN;
    };
    var busto = get('busto'), cintura = get('cintura'), quadril = get('quadril');
    var result = form.querySelector('[data-size-calc-result]');
    if (!result) return;

    if (!busto || !cintura || !quadril) {
      result.hidden = false;
      result.setAttribute('data-state', 'error');
      result.querySelector('[data-size-calc-size]').textContent = '—';
      result.querySelector('[data-size-calc-note]').textContent =
        'Preencha busto, cintura e quadril para calcular.';
      return;
    }

    var table = JSON.parse(form.getAttribute('data-size-table') || '[]');
    var best = null, bestScore = Infinity;
    table.forEach(function (row) {
      var score =
        Math.abs(busto - row.busto) +
        Math.abs(cintura - row.cintura) * 1.2 +
        Math.abs(quadril - row.quadril);
      if (score < bestScore) { bestScore = score; best = row; }
    });

    if (!best) return;
    result.hidden = false;
    result.setAttribute('data-state', 'ok');
    result.querySelector('[data-size-calc-size]').textContent = best.size;
    result.querySelector('[data-size-calc-note]').textContent =
      'Entre dois tamanhos, a 773 recomenda o maior para compressão média e o menor para alta compressão.';

    var target = document.querySelector('[data-variant-size="' + best.size + '"]');
    if (target && !target.disabled) target.click();
  });

  /* ---------- Compre o look ---------- */
  function syncLookTotal(root) {
    var total = 0, count = 0;
    root.querySelectorAll('[data-look-item]').forEach(function (item) {
      var toggle = item.querySelector('[data-look-toggle]');
      if (toggle && toggle.checked) {
        total += parseInt(item.getAttribute('data-price'), 10) || 0;
        count += 1;
      }
    });
    var totalEl = root.querySelector('[data-look-total]');
    var countEl = root.querySelector('[data-look-count]');
    var instEl = root.querySelector('[data-look-installment]');
    var btn = root.querySelector('[data-look-add]');
    if (totalEl) totalEl.textContent = money(total);
    if (countEl) countEl.textContent = count + (count === 1 ? ' item' : ' itens');
    if (instEl) instEl.textContent = count ? '6x de ' + money(Math.round(total / 6)) + ' sem juros' : '';
    if (btn) {
      btn.textContent = count ? 'Adicionar ' + count + ' à sacola' : 'Selecione uma peça';
      btn.toggleAttribute('disabled', count === 0);
    }
  }

  document.addEventListener('change', function (e) {
    var toggle = e.target.closest('[data-look-toggle], [data-look-variant]');
    if (!toggle) return;
    var root = toggle.closest('[data-look]');
    if (!root) return;
    if (toggle.matches('[data-look-variant]')) {
      var item = toggle.closest('[data-look-item]');
      var opt = toggle.options[toggle.selectedIndex];
      item.setAttribute('data-price', opt.getAttribute('data-price') || item.getAttribute('data-price'));
    }
    syncLookTotal(root);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-look-add]');
    if (!btn) return;
    e.preventDefault();
    var root = btn.closest('[data-look]');
    var items = [];
    root.querySelectorAll('[data-look-item]').forEach(function (item) {
      var toggle = item.querySelector('[data-look-toggle]');
      var select = item.querySelector('[data-look-variant]');
      if (toggle && toggle.checked && select && select.value) {
        items.push({ id: parseInt(select.value, 10), quantity: 1 });
      }
    });
    if (!items.length) return;
    btn.dataset.loading = 'true';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(refreshCart)
      .then(function () { openDrawer('cart-drawer'); })
      .finally(function () { delete btn.dataset.loading; });
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-look]').forEach(syncLookTotal);
  });
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-look]').forEach(syncLookTotal);
  });
})();

/* ============================================================
   CAMADA DE COMPATIBILIDADE
   Hooks usados pelas seções da segunda passagem.
   ============================================================ */
(function () {
  if (window.__x773Compat) return;
  window.__x773Compat = true;

  var boot = function () {

    /* --- .reveal (complementa o data-reveal já existente) --- */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

      var scan = function () {
        document.querySelectorAll('.reveal:not(.is-in)').forEach(function (el) { io.observe(el); });
      };
      scan();
      document.addEventListener('shopify:section:load', scan);
    } else {
      document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
    }

    /* --- Setas [data-scroll] para .x-scroller --- */
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-scroll]');
      if (!b) return;
      var box = document.getElementById(b.dataset.scrollTarget);
      if (!box) return;
      var card = box.firstElementChild;
      var step = card ? card.getBoundingClientRect().width + 16 : 320;
      box.scrollBy({ left: b.dataset.scroll === 'next' ? step : -step, behavior: 'smooth' });
    });
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', boot)
    : boot();
})();

/* --- Intercepta qualquer <form action="/cart/add"> do tema ---
   Faz o POST via fetch e abre a sacola, em vez de recarregar a página. */
(function () {
  if (window.__x773Form) return;
  window.__x773Form = true;

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.setAttribute('aria-disabled', 'true'); }

    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) {
        return r.json().then(function (d) { return { ok: r.ok, data: d }; });
      })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || 'Não foi possível adicionar.');
        if (window.t773RefreshCart) {
          return window.t773RefreshCart().then(function () {
            var d = document.getElementById('cart-drawer');
            if (d) d.setAttribute('data-open', 'true');
          });
        }
      })
      .catch(function (err) {
        var msg = document.querySelector('[data-atc-error]');
        if (msg) { msg.textContent = err.message; msg.hidden = false; }
        else { form.submit(); }
      })
      .finally(function () {
        if (btn) btn.removeAttribute('aria-disabled');
      });
  });
})();

/* ------------------------------------------------------------------
   10. ALTURA DO CABEÇALHO → --header-h
   Publica a altura real do header sticky como variável global. Usada
   pelo resumo da sacola, pelos filtros da coleção e pela galeria da
   página de produto para grudar no lugar certo.
------------------------------------------------------------------ */
(function () {
  var header = document.querySelector('[data-header]');
  if (!header) return;

  function publish() {
    document.documentElement.style.setProperty(
      '--header-h', Math.round(header.getBoundingClientRect().height) + 'px'
    );
  }

  publish();
  window.addEventListener('load', publish);

  if (typeof ResizeObserver === 'function') {
    new ResizeObserver(publish).observe(header);
  } else {
    window.addEventListener('resize', publish);
  }

  document.addEventListener('shopify:section:load', publish);
})();

/* ==================================================================
   773 — PRAZO DE ENTREGA (fonte única)

   Cole este bloco no FIM do arquivo assets/773-utils.js.

   Toda data de entrega da loja passa por aqui: página de produto,
   sacola e qualquer bloco novo. Antes cada seção fazia a própria
   conta — a página somava postagem + transporte e a sacola contava
   só o transporte, e a mesma compra aparecia com duas datas
   diferentes na mesma tela.

   COMO USAR EM QUALQUER SEÇÃO
     var e = window.t773Entrega(postagem, transporte);
     e.longa     → "Segunda-feira, 7 de setembro"
     e.curta     → "07 set"
     e.numerica  → "07/09"
     e.dias      → 6
   ================================================================== */
(function () {
  if (window.t773Entrega) { return; }   /* já carregado */

  /* Soma dias úteis: pula sábado e domingo. Feriado não entra na
     conta — se precisar, a lista entra aqui um dia. */
  function somarUteis(base, dias) {
    var d = new Date(base.getTime());
    var n = 0;
    while (n < dias) {
      d.setDate(d.getDate() + 1);
      var s = d.getDay();
      if (s !== 0 && s !== 6) { n++; }
    }
    return d;
  }

  window.t773Entrega = function (postagem, transporte, base) {
    var total = (parseInt(postagem, 10) || 0) + (parseInt(transporte, 10) || 0);
    var data = somarUteis(base || new Date(), total);
    var longa = data.toLocaleDateString('pt-BR', { weekday: 'long', day: 'numeric', month: 'long' });
    return {
      data: data,
      dias: total,
      longa: longa.charAt(0).toUpperCase() + longa.slice(1),
      curta: data.toLocaleDateString('pt-BR', { day: '2-digit', month: 'short' }).replace('.', ''),
      numerica: data.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' })
    };
  };
})();